<template>
    <eg-modal :height="height" :width="width" :show="show" @close="$emit('close', false)">
        <p class="center" slot="header">Dados do contratante</p>
        <div class="my-proposal-modal-body" slot="body">
            <div class="contractor-data-info">
                <div class="info-grid">
                    <p class="info-title" v-if="competition.contractorName">Contratante:</p>
                    <p class="info-data" :title="competition.contractorName">{{ competition.contractorName }}</p>
                </div>
                <div>
                    <p class="info-title" v-if="competition.constructionResponsible">Responsável pela cotação:</p>
                    <p class="info-data" :title="competition.constructionResponsible">
                        {{ competition.constructionResponsible }}
                    </p>
                </div>
                <div>
                    <p class="info-title" v-if="competition.phoneVisible">Telefone para contato:</p>
                    <p class="info-data" :title="competition.contractorPhone">{{ competition.contractorPhone }}</p>
                </div>
                <div v-if="competition.showContactEmail">
                    <p class="info-title">E-mail do contratante:</p>
                    <p class="info-data" :title="competition.contractorEmail">{{ competition.contractorEmail }}</p>
                </div>
                <div>
                    <p class="info-title" v-if="competition.technicalVisitResponsible">Responsável pela visita:</p>
                    <p class="info-data" :title="competition.technicalVisitResponsible">
                        {{ competition.technicalVisitResponsible }}
                    </p>
                </div>
                <div>
                    <p class="info-title" v-if="competition.technicalVisitResponsiblePhone">
                        Telefone do responsável pela visita:
                    </p>
                    <p class="info-data" :title="competition.technicalVisitResponsiblePhone">
                        {{ competition.technicalVisitResponsiblePhone }}
                    </p>
                </div>
            </div>
        </div>
    </eg-modal>
</template>

<script>
export default {
    name: 'ContractorDetails',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean, competition: Object },
};
</script>

<style></style>
